

import { _deleteCookie , _getCookie } from '@/utlis/cookie';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export default initialState;